import $ from 'jquery';

$.initialize('[data-role="axios-download"][data-url]', function () {
    $(this).axiosDownloadButton();
});

$.fn.axiosDownloadButton = function () {
    let $this = $(this);
    $this.off('click.axiosDownloadButton');

    const url = $this.data('url');

    const handleClick = () => {
        return window.axiosDownload(url);
    };

    $this.on('click.axiosDownloadButton', handleClick);
};